const ALL_DEPLOY_ENV = ['PROD', 'DEV', 'UAT', 'DEMO', 'SANDBOX', 'LOCAL'] as const;

export default ALL_DEPLOY_ENV;
